import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'
import clsx from 'clsx'

interface Props {
  /** Where to navigate. Default: navigate(-1) (browser back). */
  to?: string
  /** Override the visible label; defaults to t('actions.back'). */
  label?: string
  className?: string
}

/**
 * Pill-styled back button — used at the top of every detail screen so the
 * back affordance is consistently visible and doesn't get lost as a tiny
 * text link. Matches the rounded-full visual language of the TopBar profile
 * button.
 */
export function BackButton({ to, label, className }: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <button
      onClick={() => (to ? navigate(to) : navigate(-1))}
      className={clsx(
        'flex items-center gap-1 rounded-full bg-sage-100/70 px-3 py-1.5 text-sm text-sage-800 transition hover:bg-sage-200/80 active:scale-[0.98]',
        className,
      )}
    >
      <ArrowLeft className="h-4 w-4" strokeWidth={1.8} aria-hidden />
      <span>{label ?? t('actions.back')}</span>
    </button>
  )
}
